import { Box } from '@atgfr8/atg-ui-tailwind';
import type { SidebarMenuLabelTypes } from '@components/Sidebar/Sidebar';
import { Tab } from '@components/TabsComponent/Tab';
import TabsComponent from '@components/TabsComponent/TabsComponent';
import { getMaxRateRequestsData } from '@store/Global/actions';
import { sidebarDataStore } from '@store/Global/store';
import {
  canViewMaxRateApprovals,
  getPendingMaxRateRequestCount,
} from '@store/orders/actions/rateRequestActions';
import { hasPermission } from '@utils/utils';
import PendingChecks from '@views/collapsableSidebar/pendingChecks/PendingChecks';
import {
  createSignal,
  Match,
  onMount,
  type Setter,
  Show,
  Switch,
} from 'solid-js';

import MaxRateRequests from './MaxRateRequests';

type CarrierApprovalsTab = 'Pending Checks' | 'Pending Max Rate Requests';

export const getCarrierApprovalsTitle = () =>
  canViewMaxRateApprovals() ? 'Carrier Approvals' : 'Pending Checks';

const CarrierApprovals = (props: {
  setChecked: Setter<SidebarMenuLabelTypes>;
}) => {
  const tabs = (): CarrierApprovalsTab[] => [
    ...(hasPermission('Approve Checks') ? (['Pending Checks'] as const) : []),
    'Pending Max Rate Requests',
  ];
  const [activeTab, setActiveTab] = createSignal(0);
  const activeTabName = () => tabs()[activeTab()] ?? tabs()[0];

  onMount(() => {
    if (canViewMaxRateApprovals()) {
      void getMaxRateRequestsData();
    }
  });

  const pendingCount = () =>
    getPendingMaxRateRequestCount(sidebarDataStore.maxRateRequestsData.data);

  return (
    <Show when={canViewMaxRateApprovals()} fallback={<PendingChecks />}>
      <Box class="flex flex-col gap-2">
        <div>
          <TabsComponent
            tabs={tabs().map((tab) => (
              <Tab>
                {tab === 'Pending Max Rate Requests'
                  ? `${tab} (${pendingCount()})`
                  : tab}
              </Tab>
            ))}
            border={true}
            tabStyleClasses="rounded-t-lg"
            tabContainerStyles="items-center"
            activeStyling="bg-[#ffe8b7]"
            activeTab={activeTab()}
            onTabClick={setActiveTab}
          />
          <div class="border-t border-gray-300" />
        </div>
        <Switch>
          <Match when={activeTabName() === 'Pending Checks'}>
            <PendingChecks />
          </Match>
          <Match when={activeTabName() === 'Pending Max Rate Requests'}>
            <MaxRateRequests setChecked={props.setChecked} />
          </Match>
        </Switch>
      </Box>
    </Show>
  );
};

export default CarrierApprovals;
